import { render, staticRenderFns } from "./addLabeltemplate.vue?vue&type=template&id=cbdfa76a&scoped=true"
import script from "./addLabeltemplate.vue?vue&type=script&lang=js"
export * from "./addLabeltemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdfa76a",
  null
  
)

export default component.exports